(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kit-perfeito-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.kp-tabs').forEach(function (root) {
    root.querySelectorAll('[data-kp-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-kp-tab');
        root.querySelectorAll('[data-kp-tab]').forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        root.querySelectorAll('[data-kp-panel]').forEach(function (panel) {
          if (panel.getAttribute('data-kp-panel') === target) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rastreio-pedido"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRastreio(root) {
      if (root.dataset.rpInit) return;
      root.dataset.rpInit = '1';

      var consultaUrl = root.dataset.consultaUrl;
      var rastreioUrl = root.dataset.rastreioUrl;
      var form = root.querySelector('.rp__form');
      var input = root.querySelector('.rp__input');
      var submitBtn = root.querySelector('.rp__submit');
      var feedback = root.querySelector('.rp__feedback');
      var results = root.querySelector('.rp__results');
      var trackCache = {};

      var STEPS = ['Pedido aprovado', 'Em separação', 'Pronto para envio', 'Em transporte', 'Entregue'];
      var STATUS_STEP = {
        'aprovado': 1, 'pagamento aprovado': 1,
        'faturamento': 2, 'separado': 2,
        'pronto para envio': 3,
        'coletado': 4, 'em transporte': 4,
        'entregue': 5
      };

      function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }

      function detectParam(raw) {
        var v = raw.trim();
        if (!v) return null;
        if (v.indexOf('@') !== -1) return { email: v };
        var digits = v.replace(/\D/g, '');
        if (digits.length === 11 && digits.length === v.replace(/[.\-\s]/g, '').length) return { cpf: digits };
        return { codigo_rastreio: v };
      }

      function fmtDate(iso, withTime) {
        if (!iso) return '';
        var d = new Date(String(iso).replace(' ', 'T'));
        if (isNaN(d)) return '';
        var opts = { day: '2-digit', month: '2-digit', year: 'numeric' };
        if (withTime) { opts.hour = '2-digit'; opts.minute = '2-digit'; }
        return d.toLocaleString('pt-BR', opts).replace(',', ' às');
      }

      function showFeedback(msg, isError) {
        feedback.textContent = msg;
        feedback.hidden = false;
        feedback.classList.toggle('rp__feedback--error', !!isError);
      }

      function clearFeedback() {
        feedback.hidden = true;
        feedback.textContent = '';
      }

      function stepFor(status) {
        return STATUS_STEP[String(status || '').trim().toLowerCase()] || 0;
      }

      function statusBadge(status) {
        var s = String(status || '').trim();
        var low = s.toLowerCase();
        var cls = 'rp-card__status';
        if (low === 'entregue') cls += ' rp-card__status--done';
        if (low === 'cancelado') cls += ' rp-card__status--cancel';
        return '<span class="' + cls + '">' + esc(s || 'Em processamento') + '</span>';
      }

      function stepsHtml(status) {
        var low = String(status || '').trim().toLowerCase();
        if (low === 'cancelado') return '';
        var active = stepFor(status);
        if (!active) return '';
        var html = '<div class="rp-steps" aria-hidden="true">';
        for (var i = 0; i < STEPS.length; i++) {
          html += '<div class="rp-steps__item' + (i < active ? ' is-active' : '') + '">'
            + '<div class="rp-steps__dot"></div>'
            + '<span class="rp-steps__label">' + STEPS[i] + '</span></div>';
        }
        return html + '</div>';
      }

      function itemsHtml(pedido) {
        var itens = Array.isArray(pedido.itens) ? pedido.itens : [];
        var names = itens.map(function (it) { return it && (it.nome || it.name); }).filter(Boolean);
        if (!names.length && pedido.classificacao) names = [pedido.classificacao];
        if (!names.length) return '';
        return '<ul class="rp-card__items">' + names.map(function (n) {
          return '<li>' + esc(n) + '</li>';
        }).join('') + '</ul>';
      }

      function cardHtml(pedido, index) {
        var numero = pedido.numero || pedido.numeroBling || pedido.numeroOmie || pedido.id;
        var cidade = pedido.cidadeEntrega || pedido.cidade;
        var estado = pedido.estadoEntrega || pedido.estado;
        var codigo = (pedido.codigo_rastreio || '').trim();
        var meta = [];
        if (pedido.transportadora) meta.push(esc(pedido.transportadora));
        if (cidade) meta.push(esc(cidade + (estado ? ' - ' + estado : '')));
        if (pedido.previsaoEntrega) meta.push('Previsão: ' + fmtDate(pedido.previsaoEntrega));
        if (codigo) meta.push('<span class="rp-card__code">' + esc(codigo) + '</span>');

        return '<article class="rp-card" data-index="' + index + '">'
          + '<div class="rp-card__top"><div>'
          + '<span class="rp-card__num">Pedido ' + esc('#' + numero) + '</span>'
          + (pedido.created_at ? '<span class="rp-card__date">Realizado em ' + fmtDate(pedido.created_at) + '</span>' : '')
          + '</div>' + statusBadge(pedido.status) + '</div>'
          + stepsHtml(pedido.status)
          + itemsHtml(pedido)
          + (meta.length ? '<div class="rp-card__meta">' + meta.join('<span aria-hidden="true">·</span>') + '</div>' : '')
          + (codigo
            ? '<button type="button" class="rp-card__track-btn" data-codigo="' + esc(codigo) + '">'
              + '<span class="rp-card__track-label">Ver rastreamento</span>'
              + '<svg class="rp__caret" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>'
              + '</button><div class="rp-card__track" hidden></div>'
            : '<p class="rp-timeline__empty">Assim que o pedido for postado, o código de rastreio aparece aqui.</p>')
          + '</article>';
      }

      // Traduz o evento da J&T para uma frase amigável; cai no desc limpo se não reconhecer o tipo.
      function eventText(ev) {
        var tipo = String(ev.scanType || '').toLowerCase();
        var cidade = ev.scanNetworkCity || ev.scanNetworkName || '';
        var destino = ev.nextStopName || '';
        if (tipo.indexOf('coleta') !== -1) return 'Pedido coletado pela transportadora' + (cidade ? ' em ' + cidade : '');
        if (tipo.indexOf('expedi') !== -1) return 'Saiu de ' + (cidade || 'unidade J&T') + (destino ? ' com destino a ' + destino : '');
        if (tipo.indexOf('recebimento') !== -1) return 'Chegou à unidade da transportadora' + (cidade ? ' em ' + cidade : '');
        if (tipo.indexOf('saída para entrega') !== -1 || tipo.indexOf('saiu para entrega') !== -1 || tipo.indexOf('rota de entrega') !== -1) return 'Saiu para entrega' + (cidade ? ' em ' + cidade : '') + ' \u{1F69A}';
        if (tipo.indexOf('assinatura') !== -1 || tipo.indexOf('entreg') !== -1 || tipo.indexOf('pod') !== -1) return 'Pedido entregue' + (cidade ? ' em ' + cidade : '') + ' ✅';
        if (tipo.indexOf('problem') !== -1 || tipo.indexOf('ocorr') !== -1) return 'Ocorrência no transporte' + (cidade ? ' em ' + cidade : '');
        var desc = String(ev.desc || '').replace(/【/g, ' ').replace(/】/g, ' ').replace(/\s+/g, ' ').trim();
        return desc || 'Movimentação registrada';
      }

      function timelineHtml(details) {
        if (!details || !details.length) {
          return '<p class="rp-timeline__empty">Objeto postado. Aguardando a primeira movimentação da transportadora — em geral aparece em até 1 dia útil.</p>';
        }
        var sorted = details.slice().sort(function (a, b) {
          return String(b.scanTime || '').localeCompare(String(a.scanTime || ''));
        });
        return '<ol class="rp-timeline">' + sorted.map(function (ev) {
          return '<li class="rp-timeline__item">'
            + '<span class="rp-timeline__desc">' + esc(eventText(ev)) + '</span>'
            + '<span class="rp-timeline__time">' + esc(fmtDate(ev.scanTime, true)) + '</span>'
            + '</li>';
        }).join('') + '</ol>';
      }

      // Se a transportadora está à frente do status interno, sobe o badge e a barra do card.
      function syncCardWithTracking(btn, details) {
        if (!details || !details.length) return;
        var card = btn.closest('.rp-card');
        if (!card) return;
        var delivered = details.some(function (ev) {
          var t = String(ev.scanType || '').toLowerCase();
          return t.indexOf('assinatura') !== -1 || t.indexOf('pod') !== -1;
        });
        var badge = card.querySelector('.rp-card__status');
        var dots = card.querySelectorAll('.rp-steps__item');
        var current = card.querySelectorAll('.rp-steps__item.is-active').length;
        var target = delivered ? 5 : 4;
        if (target <= current) return;
        dots.forEach(function (item, i) { item.classList.toggle('is-active', i < target); });
        if (badge) {
          badge.textContent = delivered ? 'Entregue' : 'Em transporte';
          badge.classList.toggle('rp-card__status--done', delivered);
        }
      }

      function loadTracking(btn, container, codigo, openAfter) {
        if (trackCache[codigo]) {
          container.innerHTML = trackCache[codigo];
          if (openAfter) { container.hidden = false; btn.classList.add('is-open'); }
          return;
        }
        btn.disabled = true;
        btn.querySelector('.rp-card__track-label').textContent = 'Carregando...';
        fetch(rastreioUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ codigo: codigo })
        })
          .then(function (res) { return res.ok ? res.json() : Promise.reject(new Error('http ' + res.status)); })
          .then(function (json) {
            var details = json && json.data && json.data[0] ? json.data[0].details : null;
            trackCache[codigo] = timelineHtml(details);
            syncCardWithTracking(btn, details);
          })
          .catch(function () {
            container.dataset.retry = '1';
            trackCache[codigo] = '';
            container.innerHTML = '<p class="rp-timeline__empty">Não foi possível carregar o rastreamento agora. Tente novamente em instantes.</p>';
          })
          .then(function () {
            if (trackCache[codigo]) container.innerHTML = trackCache[codigo];
            btn.disabled = false;
            btn.querySelector('.rp-card__track-label').textContent = 'Ver rastreamento';
            if (openAfter) { container.hidden = false; btn.classList.add('is-open'); }
          });
      }

      results.addEventListener('click', function (e) {
        var btn = e.target.closest('.rp-card__track-btn');
        if (!btn) return;
        var container = btn.nextElementSibling;
        var codigo = btn.dataset.codigo;
        var willOpen = container.hidden;
        if (willOpen && (!container.innerHTML || container.dataset.retry)) {
          delete container.dataset.retry;
          delete trackCache[codigo];
          loadTracking(btn, container, codigo, true);
        } else {
          container.hidden = !willOpen;
          btn.classList.toggle('is-open', willOpen);
        }
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var params = detectParam(input.value);
        if (!params) {
          showFeedback('Digite o código de rastreio, o e-mail ou o CPF usado na compra.', true);
          return;
        }
        clearFeedback();
        results.hidden = true;
        results.innerHTML = '';
        submitBtn.disabled = true;
        submitBtn.classList.add('is-loading');

        fetch(consultaUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(params)
        })
          .then(function (res) {
            if (res.status === 404) return { notFound: true };
            if (!res.ok) throw new Error('http ' + res.status);
            return res.json();
          })
          .then(function (json) {
            if (json.notFound) {
              showFeedback('Não encontramos nenhum pedido com esse dado. Confira se digitou certo — ou fale com a gente no WhatsApp.', true);
              return;
            }
            var pedidos = (json && json.pedidos) || [];
            if (!pedidos.length) {
              showFeedback('Não encontramos nenhum pedido com esse dado. Confira se digitou certo — ou fale com a gente no WhatsApp.', true);
              return;
            }
            var nome = pedidos[0].nome || '';
            var firstName = nome.trim().split(/\s+/)[0];
            if (firstName && (params.email || params.cpf)) {
              showFeedback('Olá, ' + firstName + '! Encontramos ' + (pedidos.length === 1 ? '1 pedido' : pedidos.length + ' pedidos') + ' 👇');
            }
            results.innerHTML = pedidos.map(cardHtml).join('');
            results.hidden = false;
            // com um pedido só, já abre a timeline direto
            if (pedidos.length === 1) {
              var btn = results.querySelector('.rp-card__track-btn');
              if (btn) loadTracking(btn, btn.nextElementSibling, btn.dataset.codigo, true);
            }
          })
          .catch(function () {
            showFeedback('Tivemos um problema ao consultar seu pedido. Tente novamente em instantes.', true);
          })
          .then(function () {
            submitBtn.disabled = false;
            submitBtn.classList.remove('is-loading');
          });
      });
    }

    document.querySelectorAll('.rp').forEach(initRastreio);
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('.rp').forEach(initRastreio);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopee-banner-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sbc]').forEach(function (root) {
    var track = root.querySelector('[data-sbc-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-sbc-dot]'));
    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;

    var current = 0;
    var timer = null;
    var autoplay = root.dataset.autoplay === 'true';
    var interval = parseInt(root.dataset.interval, 10) || 5000;

    function setActive(index) {
      current = index;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function goTo(index, smooth) {
      var slide = slides[index];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(index);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        stop();
        goTo(parseInt(dot.dataset.sbcDot, 10));
        start();
      });
    });

    var scrollDebounce;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(function () {
        var center = track.scrollLeft + track.clientWidth / 2;
        var closest = 0;
        var minDist = Infinity;
        slides.forEach(function (slide, i) {
          var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          var dist = Math.abs(slideCenter - center);
          if (dist < minDist) {
            minDist = dist;
            closest = i;
          }
        });
        setActive(closest);
      }, 80);
    }, { passive: true });

    function start() {
      if (!autoplay || slides.length < 2) return;
      stop();
      timer = setInterval(function () {
        goTo((current + 1) % slides.length);
      }, interval);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    track.addEventListener('touchstart', stop, { passive: true });
    track.addEventListener('touchend', start, { passive: true });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    start();
  });

  } catch(e) { console.error(e); }
})();
})();
